<template>
  <div class="container-box">
    <h2 class="title-type-1">
      VX 리포트
      <v-tooltip right content-class="tooltip-custom-1">
        <template v-slot:activator="{ on, attrs }">
          <v-icon class="ico-help-1" v-bind="attrs" v-on="on">mdi-help</v-icon>
        </template>
        <span
          >집행한 캠페인의 결과 데이터를 확인하고, 엑셀 파일로 다운로드 하실 수
          있습니다.</span
        >
      </v-tooltip>
    </h2>

    <div class="search-box-2">
      <div class="form-row-1">
        <p class="label">조회 기간</p>
        <div class="write-con d-flex align-center">
          <div class="datepicker-type-1">
            <v-icon>mdi-calendar-blank</v-icon>
            <date-range-picker
              v-model="dateRange"
              :locale-data="{
                format: 'yyyy-mm-dd',
                applyLabel: '확인',
                cancelLabel: '취소',
              }"
              opens="right"
              @update="updateDateRange"
            ></date-range-picker>
          </div>
          <div class="ml-2">
            <v-btn
              large
              depressed
              max-height="40px"
              color="#fecd06"
              min-width="104px"
              class="button-type-1"
              @click.prevent="registerReportUser"
            >
              조회
            </v-btn>
          </div>
          <div class="ml-2">
            <v-btn
              large
              depressed
              max-height="40px"
              color="#fecd06"
              class="button-type-1"
              @click="exportReportData"
            >
              <v-icon left> mdi-download </v-icon>
              통합 리포트
            </v-btn>
          </div>
        </div>
      </div>

      <div class="form-row-1 mt-4">
        <p class="label">캠페인</p>
        <div class="write-con">
          <div class="search-box-1">
            <div class="search-1">
              <div class="input relative">
                <v-text-field
                  placeholder="캠페인명"
                  v-model="campaignName"
                  class="input-custom-2"
                  height="40px"
                  solo
                ></v-text-field>
                <v-btn icon class="btn" @click.prevent="registerReportUser">
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="boardLists.length > 0" class="mt-16">
      <div class="d-flex justify-space-between">
        <h3 class="title-type-2">
          <strong>캠페인</strong>
          집행 결과
        </h3>

        <vue-json-to-csv
          :json-data="customLists"
          :csv-title="'캠페인 집행 결과'"
        >
          <v-btn
            large
            depressed
            max-height="40px"
            color="#fecd06"
            class="button-type-1"
          >
            <v-icon left> mdi-download </v-icon>
            엑셀 다운로드
          </v-btn>
        </vue-json-to-csv>
      </div>

      <div class="table-wrap">
        <v-data-table
          :headers="boardHeaders"
          :items="boardLists"
          :page.sync="page"
          :items-per-page="itemsPerPage"
          class="board-list-1"
          hide-default-footer
          @page-count="pageCount = $event"
          :expanded.sync="expanded"
          show-expand
          :single-expand="true"
        >
          <template v-slot:item="{ item, expand, isExpanded }">
            <tr>
              <td>
                <router-link
                  :to="{
                    name: 'reportCampaign',
                    params: {
                      id: item.id,
                      dateRanges: dateRange,
                    },
                  }"
                >
                  {{ item.name }}
                </router-link>
              </td>
              <td>
                {{ item.advertiser.name }}
              </td>
              <td>
                <span v-if="item.start_at && item.end_at">
                  {{ item.start_at | moment('YYYY.MM.DD') }}
                  ~
                  {{ item.end_at | moment('YYYY.MM.DD') }}
                </span>
                <span v-else>-</span>
              </td>
              <td>
                {{ mediaNames(item.medias) }}
              </td>
              <td>
                {{ mediaInventoryCount(item.medias) }}
              </td>
              <td>
                {{ item.impr | comma }}
              </td>
              <td>
                {{ item.click | comma }}
              </td>
              <td>
                {{ item.ctr ? item.ctr.toFixed(2) + '%' : '-' }}
              </td>
              <td>
                {{ item.status }}
              </td>
              <td>
                <v-btn
                  v-if="item.medias.length > 1"
                  icon
                  @click="expand(!isExpanded)"
                  class="v-data-table__expand-icon"
                  :class="{ 'v-data-table__expand-icon--active': isExpanded }"
                >
                  <v-icon>mdi-chevron-down</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
          <template v-slot:expanded-item="{ item }">
            <tr
              v-for="(media, index) in item.medias"
              :key="item.agency.id + '_m' + index"
            >
              <td></td>
              <td></td>
              <td></td>
              <td>{{ media.name }}</td>
              <td>{{ media.inventory_cnt }}</td>
              <td>{{ media.impr | comma }}</td>
              <td>{{ media.click | comma }}</td>
              <td>{{ media.ctr ? media.ctr.toFixed(2) + '%' : '-' }}</td>
              <td></td>
              <td></td>
            </tr>
          </template>
        </v-data-table>
      </div>
      <div class="pagination-1">
        <div class="sel-sort">
          <span>페이지당 행개수</span>
          <v-select
            :items="pageSel"
            :label="pageSel[0]"
            v-model="pageSelChoice"
            item-color="#000"
            class="input-custom-1"
            height="40px"
            solo
            @change="itemsPerPage = parseInt($event, 10)"
          ></v-select>
        </div>

        <v-btn
          icon
          :plain="true"
          :ripple="false"
          :disabled="page == 1"
          @click="page = 1"
        >
          <v-icon>mdi-page-first</v-icon>
        </v-btn>

        <v-pagination
          v-model="page"
          :length="pageCount"
          total-visible="10"
          color="transparent"
        ></v-pagination>

        <v-btn
          icon
          :plain="true"
          :ripple="false"
          :disabled="page == pageCount"
          @click="page = pageCount"
        >
          <v-icon>mdi-page-last</v-icon>
        </v-btn>
      </div>
    </div>

    <SystemAlert v-model="showSystemAlert">
      <div slot="noti-text">{{ logResult }}</div>
      <div slot="noti-btns">
        <v-btn
          large
          depressed
          max-height="40px"
          min-width="104px"
          color="#fecd06"
          class="button-type-1"
          @click.stop="showSystemAlert = false"
        >
          확인
        </v-btn>
      </div>
    </SystemAlert>
  </div>
</template>

<script>
import DateRangePicker from 'vue2-daterange-picker';
import SystemAlert from '~@/modal/SystemAlert.vue';
import bus from '@/utils/bus.js';
import { reportUserList } from '@/api/report';
import { toISOFormattedDate } from '@/utils/validation';
import moment from 'moment';
import VueJsonToCsv from 'vue-json-to-csv';
import axios from 'axios';

let today = new Date();
today.setHours(0, 0, 0, 0);
today = moment(today).add(-1, 'months').subtract(1, 'days').toDate();
let today2 = moment(today).add(1, 'months');

export default {
  components: {
    DateRangePicker,
    SystemAlert,
    VueJsonToCsv,
  },
  data: () => ({
    dateRange: {
      startDate: today,
      endDate: today2,
    },
    campaignName: '',
    expanded: [],
    boardHeaders: [
      { text: '캠페인 명', value: 'name', sortable: false },
      {
        text: '광고주',
        value: 'advertiser.name',
        width: '13%',
        sortable: false,
      },
      { text: '집행 기간', value: '', width: '16%', sortable: false },
      { text: '집행 매체', value: 'medias', width: '14%', sortable: false },
      { text: '상품(지면)수', value: 'medias', width: '9%', sortable: false },
      { text: '노출', value: 'impr', width: '9%', sortable: false },
      { text: '클릭', value: 'click', width: '9%', sortable: false },
      { text: 'CTR', value: 'ctr', width: '7%', sortable: false },
      { text: '상태', value: 'status', width: '7%', sortable: false },
      { text: '', value: 'data-table-expand' },
    ],
    boardLists: [],
    customLists: [],
    pageSel: ['10', '25', '50', '100'],
    pageSelChoice: '10',
    page: 1,
    pageCount: 0,
    itemsPerPage: 10,
    showSystemAlert: false,
    logResult: '',
    paramsObj: null,
  }),
  computed: {
    mediaNames() {
      return medias => {
        let media_name = medias[0].name;
        if (medias.length > 1) {
          let media_count = medias.length - 1;
          media_name = `${media_name} 외 ${media_count}개`;
        }
        return media_name;
      };
    },
    mediaInventoryCount() {
      return medias => {
        let count = 0;
        medias.forEach(media => {
          count += media.inventory_cnt;
        });
        return count;
      };
    },
  },
  methods: {
    async registerReportUser() {
      bus.$emit('start:spinner');
      try {
        let startDate = toISOFormattedDate(this.dateRange.startDate);
        let endDate = toISOFormattedDate(this.dateRange.endDate);

        bus.$emit('start:spinner');

        const resultData = {
          start_at: startDate,
          end_at: endDate,
          name: this.campaignName,
        };

        const { data } = await reportUserList(resultData);

        if (data.list.length > 0) {
          this.boardLists = data.list;
          this.boardLists.map(item => {
            if (item.is_valid === 'Y') {
              if (this.$moment(item.start_at) > this.$moment(new Date())) {
                item.status = '대기중';
              } else if (this.$moment(item.end_at) > this.$moment(new Date())) {
                item.status = '진행중';
              } else {
                item.status = '종료';
              }
            } else {
              item.status = '종료';
            }

            item.medias.forEach(media => {
              let impr = 0,
                click = 0;
              media.inventories.forEach(inventory => {
                inventory.days.forEach(day => {
                  impr += day.impr;
                  click += day.click;
                });
              });

              media.impr = impr;
              media.click = click;
              media.ctr = (click / impr) * 100;
            });
          });

          const exel = [];
          data.list.forEach(da => {
            exel.push({
              캠페인명: da.name,
              광고주: da.advertiser.name,
              '집행 기간': `${moment(da.start_at).format(
                'YYYY.MM.DD',
              )} ~ ${moment(da.end_at).format('YYYY.MM.DD')}`,
              '상품(지면)수': da.medias[0].inventory_cnt,
              노출: da.impr,
              클릭: da.click,
              CTR: da.ctr ? da.ctr.toFixed(2) + '%' : '-',
              상태: da.status,
            });
          });
          this.customLists = exel;
        } else {
          this.showSystemAlert = true;
          this.logResult = '조회된 목록이 없습니다.';
          this.boardLists = [];
        }
        bus.$emit('end:spinner');
      } catch (error) {
        bus.$emit('end:spinner');
        console.log(error.response);
      }
    },
    async exportReportData() {
      let startDate = toISOFormattedDate(this.dateRange.startDate);
      let endDate = toISOFormattedDate(this.dateRange.endDate);
      let byDate = this.$moment(this.dateRange.endDate).subtract(1, 'months'); // endDate로부터 1개월 계산

      if (this.dateRange.startDate >= byDate) {
        await axios({
          method: 'POST',
          url: `${process.env.VUE_APP_API_URL}api/reports/user/download`,
          responseType: 'arraybuffer',
          headers: {
            Authorization: `Bearer ${this.$store.state.token}`,
          },
          data: {
            start_at: startDate,
            end_at: endDate,
          },
        }).then(response => {
          console.log('response', response);
          const contentDisposition = response.headers['content-disposition'];
          const filename = contentDisposition
            .split(';')
            .filter(r => r.includes('filename'))[0]
            .split('=')[1];
          const url = window.URL.createObjectURL(
            new Blob([response.data], {
              type: response.headers['content-type'],
            }),
          );
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
        });
      } else {
        this.showSystemAlert = true;
        this.logResult = '조회기간은 최대 1개월까지 입니다.';
      }
    },
    updateDateRange() {
      this.dateRange.startDate.setHours(0, 0, 0, 0);
      this.dateRange.endDate.setHours(0, 0, 0, 0);
    },
  },
  created() {
    this.registerReportUser();
  },
};
</script>
